import { Grid, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { Navigate } from 'react-router'
import { PageBody } from '../../routes/PageBody'
import { BankingInstructions } from '../onboarding/steps/banking'
import { useOrg } from '../organization/useOrg'
import { AliceCardConnectionInfo } from './AliceCardProgramHealthcheck'
import { useMayManageAliceCardProgram } from './aliceCardProgramUtils'
import { isOrgFundingConnected } from './funding/fundingUtils'

export const AliceCardProgramPage = () => {
  const mayManageAliceCardProgram = useMayManageAliceCardProgram()
  const org = useOrg()
  if (!org) return null

  if (!mayManageAliceCardProgram) return null
  const fundingConnected = isOrgFundingConnected(org)
  if (!fundingConnected) return <Navigate to="account/setup" replace />

  return (
    <PageBody maxWidth="lg">
      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Instructions
          </Typography>
          <BankingInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <AliceCardConnectionInfo org={org} />
        </Grid>
      </Grid>
    </PageBody>
  )
}
